import { Box, CardMedia, Typography } from "@mui/material";
import React, { useState } from "react";
import CloudUploadIcon from "../../../../Custom-imeges/Workflows-Icons/CloudUploadIcon";

interface ImageSelectedProps {
  handleOpenSelectionImageModal: () => void;
  imageSelected: File | string | null;
  isGenerateImgLoading?: boolean;
}

const ImageSelected = ({
  handleOpenSelectionImageModal,
  imageSelected,
  isGenerateImgLoading,
}: ImageSelectedProps) => {
  const [uploadImageHover, setUploadImageHover] = useState(false);
  // check if imageSelected is a file or a string
  const imageUrl =
    imageSelected instanceof File
      ? URL.createObjectURL(imageSelected)
      : imageSelected;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        onClick={
          !isGenerateImgLoading ? handleOpenSelectionImageModal : undefined
        }
        onMouseEnter={() => setUploadImageHover(true)}
        onMouseLeave={() => setUploadImageHover(false)}
        sx={{
          position: "relative",
          width: "160px",
          height: "160px",
          cursor: isGenerateImgLoading ? "default" : "pointer",
          userSelect: "none",
        }}
      >
        <CardMedia
          component="img"
          image={imageUrl || ""}
          alt="Selected"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "6px",
          }}
        />
        {uploadImageHover && !isGenerateImgLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.70)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
              }}
            >
              <CloudUploadIcon />
              <Typography
                sx={{
                  color: "#12B6EA",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                }}
              >
                Click to change image
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ImageSelected;
